module.exports = __webpack_public_path__ + "img/rozhkov_500.132efed2.jpg";